module.exports = __webpack_public_path__ + "static/img/hot-tab-btn.37f2dbf.gif";